import React from 'react';
import MissingMerchantDocument from './missing-merchant-document.component';
export default function MissingDocument(props) {
    return <MissingMerchantDocument {...props} />;
}
